import React from "react";
import {
  Avatar,
  Box,
  Chip,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";

const roleMap = {
  1: "Super Admin",
  2: "Admin",
  3: "Manager",
  4: "User",
};

export default function ContactTab({ contacts = [], onAdd, onEdit, onDelete }) {
  return (
    <Grid container spacing={3}>
      {contacts.length === 0 ? (
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              p: 5,
              textAlign: "center",
              border: "2px dashed #E5E7EB",
              borderRadius: 3,
            }}
          >
            <Typography color="text.secondary">No Contact Found</Typography>
          </Paper>
        </Grid>
      ) : (
        contacts.map((contact) => (
          <Grid item xs={12} md={6} lg={4} key={contact._id}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                border: "1px solid #E5E7EB",
                borderRadius: 3,
                height: "100%",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Box display="flex" alignItems="center">
                  <Avatar sx={{ mr: 2 }}>
                    {contact?.name?.charAt(0)?.toUpperCase()}
                  </Avatar>

                  <Box>
                    <Typography fontWeight={400} fontSize={16} color={"2b2b2b"}>
                      {contact?.name}
                    </Typography>

                    <Typography fontSize={13} color="text.secondary">
                      {contact?.roleInOrganization}
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  <IconButton onClick={() => onEdit(contact)}>
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>

                  <IconButton color="error" onClick={() => onDelete(contact)}>
                    <DeleteOutlineOutlinedIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>

              <Box display="flex" alignItems="center" mb={1}>
                <EmailOutlinedIcon
                  sx={{
                    mr: 1,
                    fontSize: 18,
                  }}
                />

                <Typography fontSize={16} fontWeight={400} color={"253041"}>
                  {contact.emailAddress || "-"}
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" mb={1}>
                <PhoneOutlinedIcon
                  sx={{
                    mr: 1,
                    fontSize: 18,
                  }}
                />

                <Typography fontSize={16} fontWeight={400} color={"253041"}>
                  {contact.phoneNumber || "-"}
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" mb={1}>
                <LocationOnOutlinedIcon
                  sx={{
                    mr: 1,
                    fontSize: 18,
                  }}
                />

                <Typography fontSize={16} fontWeight={400} color={"253041"}>
                  {contact.clientAddress || "-"}
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                <BrandingWatermarkOutlinedIcon
                  sx={{
                    mr: 1,
                    fontSize: 18,
                  }}
                />

                {contact.associatedBrands
                  ?.flatMap((item) => item.split(","))
                  .map((brand, index) => (
                    <Typography
                      key={index}
                      fontSize={16}
                      fontWeight={400}
                      color={"253041"}
                    >
                      {brand.trim()}
                    </Typography>
                  ))}
              </Box>

              <Chip
                className="mt-2"
                label={roleMap[contact.userRoleId] || "User"}
                size="small"
                sx={{
                  bgcolor: contact.userRoleId === 1 ? "#E8f5e9" : "#EFF8FF",
                  color: contact.userRoleId === 1 ? "#2e7d32" : "#175CD3",
                  // border: `1px solid ${
                  //   contact.userRoleId === 1 ? "#ABEFC6" : "#B2DDFF"
                  // }`,
                  fontWeight: 400,
                }}
              />
            </Paper>
          </Grid>
        ))
      )}
    </Grid>
  );
}
